import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  formChanged: false,
  confirmationChangeModalShow: false,
  onConfirmCallbackFunction: null,
  onRollbackCallbackFunction: null,
};

export type CaseFormChangeState = Readonly<typeof initialState>;

export const CaseFormChangeSlice = createSlice({
  name: 'caseFormChangeSlice',
  initialState: initialState as CaseFormChangeState,
  reducers: {
    initCaseFormChange() {
      return initialState;
    },
    setFormChanged(state, action) {
      return {
        ...state,
        formChanged: action.payload,
      };
    },
    openConfirmationModalWithCallbacks(state, action) {
      return {
        ...state,
        confirmationChangeModalShow: true,
        onConfirmCallbackFunction: action.payload.onConfirmCallbackFunction,
        onRollbackCallbackFunction: action.payload.onRollbackCallbackFunction,
      };
    },
    setConfirmationChangeModalShow(state, action) {
      return {
        ...state,
        confirmationChangeModalShow: action.payload,
      };
    },
  },
});

export const { initCaseFormChange, setFormChanged, openConfirmationModalWithCallbacks, setConfirmationChangeModalShow } =
  CaseFormChangeSlice.actions;
export default CaseFormChangeSlice.reducer;
